import axios from "axios";
import { BACKEND } from "../config/backend";

export const getStudioNameAvailability = async (studioName) => {
    const response = await axios.get(`${BACKEND}/api/v1/users/names/availability`, { params: { studioName } });
    return response.data.available;
};

export const registerUser = async (data) => {
    await axios.post(`${BACKEND}/api/v1/users`, data);
};

export const verifySetupSecret = async (formData, secret) => {
    const response = await axios.post(`${BACKEND}/api/v1/verify-setup-secret`, {
        formData,
        secret
    });
    return response.data;
};

export const TERMS_OF_USE_LINK = `${BACKEND}/pdf/Nutzungsvereinbarung.pdf`;

